export default __webpack_public_path__ + "static/media/1446.555628b9.png";